import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { Button } from "@/@core/components/mui/Button"
import DialogCloseButton from "@/components/dialog/DialogCloseButton"
import { useTranslator } from "@/hooks/useTranslator"

export const ConfirmVerifyReconciliationDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void }) => {

  const { __ } = useTranslator()

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible', maxWidth: '800px', borderRadius: '8px' }
      }}
    >
      <DialogTitle className="text-center text-[24px] font-medium">
        {__('Verify Data Reconciliation')}
        <div className="text-center text-[15px] font-normal text-[#2f2b3db3]">
          {__('This action will reconcile data between sources. Please review carefully before confirming')}
        </div>
      </DialogTitle>

      <DialogContent>
        <DialogCloseButton onClick={onClose} disableRipple>
          <i className='tabler-x' />
        </DialogCloseButton>
      </DialogContent>
      <DialogActions className="flex justify-center">
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          className="rounded-[6px] w-[144px]"
        >
          <span className="text-[15px] font-medium">
            {__('Reconcile Now')}
          </span>
        </Button>
        <Button
          onClick={onClose}
          variant="tonal"
          type="button"
          size="small"
          className="rounded-[6px] w-[104px]"
        >
          <span className="text-[15px] font-medium">
            {__('Cancel')}
          </span>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
